<template>
  <transition name="fade">
    <div class="info center">
      <audio
        :src="require('../../public/media/open.mp3')"
        ref="open"
        controls
        preload="auto"></audio>
        
      <div class="info_container">
        <div class="info_number">NO.{{number}}</div>

        <input
          type="text"
          class="info_name"
          ref="name"
          placeholder="请填写姓名"
          @focus="showClick = false"
          v-model="name"
          maxlength="5"
        >

        <transition name="fade">
          <img class="info_click" v-if="showClick" src="../assets/imgs/info_click.png" />
        </transition>

        <div class="inputNameHanlder" @click="handleName"></div>

        <!-- 省份选择框 -->
        <div class="info_provinces">
          <img class="arrow" src="../assets/imgs/info_arrow.png" />

          <div class="value" @click="selectFocus('provinces')">{{province || '请选择所在省份'}}</div>

          <select id="test" ref="provinces" v-model="province" @focus="showClick = false">
            <option style="display: none;" value="" disabled selected>请选择所在省份</option>
            <option v-for="province in provinces" :value="province" :key="province">{{province}}</option>
          </select>
        </div>

        <!-- 年份选择框 -->
        <div class="info_years">
          <img class="arrow" src="../assets/imgs/info_arrow.png" />

          <div class="value" @click="selectFocus('years')">{{year || '请选择高考年份'}}</div>

          <select ref="years" v-model="year" @focus="showClick = false">
            <option style="display: none;" value="" disabled selected>请选择高考年份</option>
            <option v-for="year in years" :value="year" :key="year">{{year}}</option>
          </select>
        </div>

        <div class="info_buttons">
          <div @click="open" class="info_btn_open" :class="{ 'open': openAnimation }">
          </div>

          <transition name="fade">
            <img class="info_open_click" v-if="showOpen && !openAnimation" src="../assets/imgs/info_click.png" /> 
          </transition>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { provinces, years } from '../assets/js/config'
import { request } from '../assets/js/baseConfig'

let warn = ["上海", "河南", "广东", "贵州"]

var throttle = function(func, delay) {     
    var timer = null;     
    var startTime = Date.now();     
    return function() {             
        var curTime = Date.now();             
        var remaining = delay - (curTime - startTime);             
        var context = this;             
        var args = arguments;             
        clearTimeout(timer);              
        if (remaining <= 0) {                    
            func.apply(context, args);                    
            startTime = Date.now();              
        } else {                    
            timer = setTimeout(func, remaining);              
        }      
    }
}
function handle() {      
    console.log(Math.random());
} 

export default {
  name: "Info",
  props: {
    number: String
  },
  data () {
    return {
      provinces, // 省列表
      years, // 年列表
      // showOpen: false, 
      name: '',
      province: '',
      year: '',
      showClick: true,
      openAnimation: false,
      isClick: false,
      isRequest: false,
      isChecked: false
    }
  },
  computed: {
    showOpen () {
      return this.name.replace('\s', '') != ''
                      && this.province != ''
                      && this.year != ''
                      && this.isChecked
    }
  },
  watch: {
    name () {
      if (this.isRequest) return

      // if (e) {
        this.isChecked = false
        this.isRequest = true

        request('paper/confilter/', {
          text: this.name
        }, 'post').then(res => {
          this.isRequest = false

          if (res.data.code == '1000') {
            console.log('true')
            this.isChecked = true

          } else {
            console.log('false')
            this.isChecked = false
            alert(res.data.code_message)
          }
        }).catch(e => {
          alert(e)

          this.isRequest = false
        }) 
      // }
    }
  },
  methods: {
    handleName () {
      this.$refs.name.focus()
    },

    selectFocus (e) {
      document.querySelector('#test').focus()
      console.log(111, e)
    },

    open () {
      if (this.year == '1977' && warn.indexOf(this.province) > -1 || this.year == '1978') {
        alert('当年的考卷飞走啦！\n试试其他考题？')

        return
      }

      if (!this.showOpen) return

      if (this.isClick) return
      this.isClick = true

      // request('paper/confilter/', {
      //   text: this.name
      // }, 'post').then(res => {
      //   // console.log(res)
      //   this.isClick = false

      //   if (res.data.code == '1000') {
          this.openAnimation = true
          this.$refs.open.play()

          this.$emit('open', {
            name: this.name,
            province: this.province,
            year: this.year
          })
  
          setTimeout(() => {
            this.$emit('submit', {
              name: this.name,
              province: this.province,
              year: this.year
            })
  
            setTimeout(() => {
              this.openAnimation = false

              this.isClick = false
            }, 1000);
          }, 1000);
      //   } else {
      //     alert(res.data.code_message)
      //   }
      // }).catch(e => {
      //   this.isClick = false

      //   alert(e)
      // })

    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .info {
    width: 750px;
    height: 1624px;
    .info_container {
      width: 723px;
      height: 1063px;
      background: url(../../public/imgs/info_bg.png);
      position: relative;
      // left: 27px;
      // top: 308px;
      left: 25px; 
      top: 313px;
      .info_click {
        position: absolute;
        top: 616px;
        left: 392px;
        animation: breath 1.5s linear infinite;
      }
      .info_number {
        font-size: 20px;
        position: absolute;
        left: 499px;
        top: 69px;
      }
      .info_name, .info_provinces, .info_years, .inputNameHanlder {
        position: absolute;
        top: 570px;
        width: 338px;
        height: 68px;
        left: 240px;
        text-align: left;
        text-indent: 21px;
        line-height: 68px;
        .value {
          font-size: 25px;
          line-height: 68px;
          // z-index: 1;
          // position: relative;
        }
        select {
          width: 453px;
          height: 68px;
          position: absolute;
          left: -118px;
          opacity: 0;
          top: 0;
        }
        .arrow {
          position: absolute;
          right: 23px;
          top: 25px;
        }
      }
      input::-webkit-input-placeholder {
        color: #876648;
        font-size: 25px;
      }
      .info_name, .inputNameHanlder {
        padding: 0;
        margin: 0;
        background: no-repeat;
        border: 0;
        outline: none;
        color: #876648;
        font-size: 25px;
      }
      .info_provinces {
        top: 640px;
      }
      .info_years {
        top: 710px;
      }
      .info_buttons {
        position: absolute;
        top: 861px;
        left: 3px;
        img {
          position: absolute;
        }
        .info_btn_open {
          width: 792px;
          height: 215px;
          background: url(../../public/imgs/info_open.png);
          position: absolute;
          left: -31px;
          bottom: -170px;
          &.open {
            animation: open 1s steps(8) forwards;
          }
        }
        .info_open_click {
          left: 359px;
          top: 102px;
          animation: breath 1.5s linear infinite;
        }
      }
    }
  }

  @keyframes open {
    to {
      background-position: 0 -1720px;
    }
  }

  @keyframes breath {
    50% {
      transform: scale(.7) translate(10px, 10px);
    }
    100% {
      transform: scale(1);
    }
  }
</style>
